import { Typography } from "@mui/material";
import { useContext, useEffect, useLayoutEffect } from "react";
import { EmptyState } from "../../components/common/empty-state";
import { Conditions } from "../../components/pages/conditions/conditions";
import { Layout } from "../../components/layout/layout";
import { Styling } from "../../components/pages/styling/styling";
import { MainContext } from "../../context/main-context";

export const NewCheckoutBuilder = () => {
  const { page } = useContext(MainContext);
  return (
    <Layout scrollable={page === "CONDITIONS"}>
      {page === "CONDITIONS" ? <Conditions /> : <Styling />}
    </Layout>
  );
};
